import { useEffect } from 'react';
import { Product } from '../types';

interface SEOProps {
    title?: string;
    description?: string;
    brand?: string | null;
    searchQuery?: string | null;
    viewingProduct?: Product | null;
}

export const useSEO = ({ title, description, brand, searchQuery, viewingProduct }: SEOProps) => {
    useEffect(() => {
        const defaultTitle = "Carbon Case SV | Cases de Fibra de Carbono Real en El Salvador";
        const defaultDescription = "Especialistas en cases de fibra de carbono real en El Salvador para iPhone y Samsung. Protección ultra ligera, acabado premium y envíos a todo el país.";
        const defaultImage = "https://carboncasesv.com/og-card.png";

        let newTitle = defaultTitle;
        let newDescription = description || defaultDescription;
        let newImage = defaultImage;

        if (viewingProduct) {
            newTitle = `${viewingProduct.name} | Fibra de Carbono Real | CarbonCase SV`;
            newDescription = `Compra el case de fibra de carbono real para ${viewingProduct.name} en El Salvador. Ultra ligero, resistente a caídas y diseño exclusivo. Envíos a todo el país.`;
            if (viewingProduct.image) {
                newImage = viewingProduct.image.startsWith('http')
                    ? viewingProduct.image
                    : `${window.location.origin}${viewingProduct.image.startsWith('/') ? '' : '/'}${viewingProduct.image}`;
            }
        } else if (brand) {
            newTitle = `Cases de Fibra de Carbono para ${brand} | Carbon Case SV`;
            newDescription = `Explora nuestra colección exclusiva de cases de fibra de carbono para ${brand}. Acabado aeroespacial, máxima protección y envíos a todo El Salvador.`;
        } else if (searchQuery) {
            newTitle = `Resultados para "${searchQuery}" | Cases de Fibra de Carbono | Carbon Case SV`;
            newDescription = `Búsqueda de cases de fibra de carbono para "${searchQuery}". Encuentra el modelo ideal con garantía y respaldo local en El Salvador.`;
        } else if (title) {
            newTitle = `${title} | Carbon Case SV`;
        }

        document.title = newTitle;

        // Meta Description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', newDescription);
        }

        // Open Graph Tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', newTitle);

        const ogDescription = document.querySelector('meta[property="og:description"]');
        if (ogDescription) ogDescription.setAttribute('content', newDescription);

        const ogImage = document.querySelector('meta[property="og:image"]');
        if (ogImage) ogImage.setAttribute('content', newImage);

        // Twitter Card Tags
        const twitterTitle = document.querySelector('meta[name="twitter:title"]');
        if (twitterTitle) twitterTitle.setAttribute('content', newTitle);

        const twitterDescription = document.querySelector('meta[name="twitter:description"]');
        if (twitterDescription) twitterDescription.setAttribute('content', newDescription);

        const twitterImage = document.querySelector('meta[name="twitter:image"]');
        if (twitterImage) twitterImage.setAttribute('content', newImage);

    }, [title, description, brand, searchQuery, viewingProduct]);
};
